// Source unique des couleurs par catégorie d'annonce.
// Keyed by ANNONCE_CATEGORIES value (slug).
// Palette subtile accordée avec la marque Hirafi (#E0561A orange, #317A55 vert).

export interface CategoryColorTokens {
  /** Fond de l'icône dans CategoryGrid */
  iconBg: string;
  /** Couleur de l'icône dans CategoryGrid */
  iconText: string;
  /** Bordure latérale (start) sur les cartes d'annonce — border-s-4 */
  border: string;
  /** Bordure haute sur les cards profil/contact — border-t-4 */
  borderTop: string;
  /** Fond du badge métier */
  badgeBg: string;
  /** Texte du badge métier */
  badgeText: string;
}

// border-s-* = propriété logique CSS (start = gauche en LTR, droite en RTL) → RTL-safe
export const CATEGORY_COLORS: Record<string, CategoryColorTokens> = {
  plumbing:      { iconBg: "bg-blue-50",   iconText: "text-blue-600",   border: "border-s-blue-400",   borderTop: "border-t-blue-400",   badgeBg: "bg-blue-50",   badgeText: "text-blue-700" },
  electricity:   { iconBg: "bg-amber-50",  iconText: "text-amber-600",  border: "border-s-amber-400",  borderTop: "border-t-amber-400",  badgeBg: "bg-amber-50",  badgeText: "text-amber-700" },
  locksmith:     { iconBg: "bg-slate-100", iconText: "text-slate-600",  border: "border-s-slate-400",  borderTop: "border-t-slate-400",  badgeBg: "bg-slate-100", badgeText: "text-slate-700" },
  carpentry:     { iconBg: "bg-orange-50", iconText: "text-orange-700", border: "border-s-orange-400", borderTop: "border-t-orange-400", badgeBg: "bg-orange-50", badgeText: "text-orange-700" },
  plaquiste:     { iconBg: "bg-gray-100",  iconText: "text-gray-600",   border: "border-s-gray-400",   borderTop: "border-t-gray-400",   badgeBg: "bg-gray-100",  badgeText: "text-gray-700" },
  pvc_aluminium: { iconBg: "bg-zinc-100",  iconText: "text-zinc-600",   border: "border-s-zinc-400",   borderTop: "border-t-zinc-400",   badgeBg: "bg-zinc-100",  badgeText: "text-zinc-700" },
  painting:      { iconBg: "bg-purple-50", iconText: "text-purple-600", border: "border-s-purple-400", borderTop: "border-t-purple-400", badgeBg: "bg-purple-50", badgeText: "text-purple-700" },
  masonry:       { iconBg: "bg-stone-100", iconText: "text-stone-700",  border: "border-s-stone-400",  borderTop: "border-t-stone-400",  badgeBg: "bg-stone-100", badgeText: "text-stone-700" },
  tiling:        { iconBg: "bg-teal-50",   iconText: "text-teal-600",   border: "border-s-teal-400",   borderTop: "border-t-teal-400",   badgeBg: "bg-teal-50",   badgeText: "text-teal-700" },
  hvac:          { iconBg: "bg-sky-50",    iconText: "text-sky-600",    border: "border-s-sky-400",    borderTop: "border-t-sky-400",    badgeBg: "bg-sky-50",    badgeText: "text-sky-700" },
  kitchen:       { iconBg: "bg-rose-50",   iconText: "text-rose-600",   border: "border-s-rose-400",   borderTop: "border-t-rose-400",   badgeBg: "bg-rose-50",   badgeText: "text-rose-700" },
  handyman:      { iconBg: "bg-green-50",  iconText: "text-green-700",  border: "border-s-green-500",  borderTop: "border-t-green-500",  badgeBg: "bg-green-50",  badgeText: "text-green-700" },
};

const DEFAULT: CategoryColorTokens = {
  iconBg: "bg-secondary",
  iconText: "text-muted-foreground",
  border: "border-s-primary/30",
  borderTop: "border-t-primary/30",
  badgeBg: "bg-secondary",
  badgeText: "text-secondary-foreground",
};

export function getCategoryColors(value: string): CategoryColorTokens {
  return CATEGORY_COLORS[value] ?? DEFAULT;
}

// Reverse map : label FR artisan → slug annonce
const LABEL_TO_SLUG: Record<string, string> = {
  "Plomberie": "plumbing",
  "Électricité": "electricity",
  "Serrurerie": "locksmith",
  "Menuiserie": "carpentry",
  "Placoplâtre": "plaquiste",
  "PVC / Aluminium": "pvc_aluminium",
  "Peinture et décoration": "painting",
  "Maçonnerie": "masonry",
  "Carrelage": "tiling",
  "Climatisation": "hvac",
  "Cuisiniste": "kitchen",
  "Artisan polyvalent": "handyman",
  "Entreprise tout corps d'état": "handyman",
};

/** Lookup par label FR (pour ArtisanCard et assimilés) */
export function getCategoryColorsByLabel(label: string): CategoryColorTokens {
  return getCategoryColors(LABEL_TO_SLUG[label] ?? "");
}
